import styled from 'styled-components'

export const DoubleBox = styled.div`
  display: grid;
  grid-template-columns: 1fr 2fr;
  gap: 1rem;
  height: calc(100% - 240px);
  min-height: 0;
  overflow: hidden;
  margin-top: 1rem;
`
